import type { Theme } from '@mui/material/styles';
import { colors, panelSx } from '@/theme/tokens';

// The Bulk Shell mockup's shared pieces (docs/design/bulk-shell-simple-ui.html).

/** A panel: hairline border, no shadow. */
export const flatPanelSx = { ...panelSx, boxShadow: 'none' } as const;

/** The table-head grey: headers, set filter chips. */
export const headBg = (theme: Theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : colors.background.tableHead);

/** A plain button (`variant="outlined"`): hairline border, paper fill, text colour. */
export const plainButtonSx = {
  p: '6px 12px',
  minWidth: 0,
  fontSize: 13,
  lineHeight: 1.5,
  color: 'text.primary',
  bgcolor: 'background.paper',
  borderColor: 'divider',
  '&:hover': { bgcolor: 'action.hover', borderColor: 'divider' },
} as const;

/** The same size for a filled button (`variant="contained"`), which has no border. */
export const primaryButtonSx = { p: '7px 13px', minWidth: 0, fontSize: 13, lineHeight: 1.5 } as const;

// Lives in lib so plain (node --test) modules can use it too.
export { typeLabel } from '@/lib/utils';

/** Hairline-bordered inputs at the form's 13 px. */
export const inputSx = {
  '& .MuiInputBase-root': { fontSize: 13, bgcolor: 'background.paper' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
} as const;

/** All / Filter / Group / Paste list: one bordered strip, the chosen part filled with ink. */
export const segmentSx = {
  display: 'inline-flex',
  mb: '10px',
  border: 1,
  borderColor: 'divider',
  borderRadius: '6px',
  overflow: 'hidden',
  '& .MuiToggleButton-root': {
    m: 0,
    border: 0,
    borderRadius: 0,
    px: '14px',
    py: '6px',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.5,
    textTransform: 'none',
    color: 'text.primary',
    bgcolor: 'background.paper',
    '&:hover': { bgcolor: 'action.hover' },
  },
  '& .MuiToggleButton-root + .MuiToggleButton-root': { borderLeft: 1, borderColor: 'divider' },
  '& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover': { bgcolor: 'text.primary', color: 'background.paper' },
} as const;
